import { useEffect, useState } from "react";
import { opApi, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

// One business, several carts: add extra live cart types on top of the primary one (e.g. barber + retail products).
export function CartAddons({ onChanged }) {
  const [d, setD] = useState(null);
  const load = () => opApi.get("/tenant/cart-type").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d) return null;
  const others = d.cart_types.filter((c) => c.live && c.key !== d.cart_type);
  const toggle = (key, on) => {
    const addons = on ? [...d.addon_cart_types, key] : d.addon_cart_types.filter((k) => k !== key);
    opApi.patch("/tenant/cart-addons", { addons }).then(() => { toast.success(on ? "Cart added" : "Cart removed — nothing was deleted"); load(); onChanged && onChanged(); })
      .catch((e) => toast.error(apiError(e.response?.data?.detail)));
  };
  return (
    <div className="mt-4 border-t pt-4" data-testid="cart-addons">
      <div className="text-sm font-semibold">Add another cart <span className="text-muted-foreground font-normal">(optional)</span></div>
      <p className="text-xs text-muted-foreground mb-2">Run more than one type of business from one dashboard, for example a barbershop that also sells products. {d.max_cart_types ? `Your plan includes ${d.max_cart_types} cart type${d.max_cart_types === 1 ? "" : "s"}.` : ""}</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {others.map((c) => (
          <label key={c.key} className="flex items-center gap-2 border border-border px-3 py-2 text-sm" data-testid={`cart-addon-${c.key}`}>
            <Switch checked={d.addon_cart_types.includes(c.key)} onCheckedChange={(v) => toggle(c.key, v)} data-testid={`cart-addon-toggle-${c.key}`} />
            {c.label}
          </label>
        ))}
      </div>
    </div>
  );
}
